import { EpisodeViewRouteParams } from '../@types/Utils.types'
import { ComicAuthorType } from '../@types/Comics.types'
import { getComicSlugFromTitle } from './utils'

export const Routes = {
  RAPTURES_PLAY_STORE:
    'https://play.google.com/store/apps/details?id:com.raptures.app',
  RAPTURES_APP_STORE: 'https://apps.apple.com/app/raptures/id1600027611',
  HOME: '/', // handled
  ORIGINS: '/origins',
  LOGIN: '/login', // handled
  SIGNUP: '/sign-up', // handled
  ACTIVITY_BOOKMARKS: '/activities/bookmarks',
  ACTIVITY_RECENT: '/activities/recent',
  ACTIVITY_FOLLOWING: '/activities/following',
  ACTIVITY_COMMENTS: '/activities/comments',
  VERIFY_EMAIL: '/auth/verify-email', // handled
  FORGOT_PASSWORD: '/auth/forgot-password', // handled
  CONFIRM_TOKEN: '/auth/forgot-password/confirm-token', // handled
  RESET_PASSWORD: '/auth/forgot-password/reset', // handled
  PROFILE: '/profile', // Done
  USER_SUBSCRIBED: '/u/following', // Done
  USER_BOOKMARKS: '/u/bookmarks', // Done
  USER_COMMENTS: '/u/comments',
  USER_SETTINGS: '/u/shop',
  LATEST_COMICS: '/comics/latest', // handled
  SEARCH_COMICS: '/comics/search',
  COMICS: '/comics',
  ACTIVITY: '/activities',
  SHOP: '/shop',
  SLICES: '/slices', // handled,
  DELETE_ACCOUNT: '/delete-account',
  ARTISTS(artist: ComicAuthorType) {
    return `/artists/${artist.id}/${getComicSlugFromTitle(artist.name)}`
  },
  GENRES(id: string, slug: string) {
    return `/comics/genres/${id}/${slug}` // handled
  },
  COMICS_VIEW(id: string, slug: string) {
    return `/comics/${id}/${slug}` // handled
  },
  EPISODE_VIEW({ comicId, comicSlug, episodeId }: EpisodeViewRouteParams) {
    return this.COMICS_VIEW(comicId, comicSlug) + `?episode=${episodeId}`
  },
}
